import React from 'react';
import { Button, Menu } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { format, isToday, isYesterday } from 'date-fns';
import { NotificationItemProps } from './types';

import './notificationItem.css';

const NotificationItem: React.FC<NotificationItemProps> = ({ notification, markAsRead, closeDropdown, navigation, downloadFile, isNextUnread }: NotificationItemProps) => {
    const handleRowClick = () => {
        if (!notification.persist && !notification.readAt) {
            markAsRead(notification.id);
        }

        if (!notification.persist) {
            closeDropdown();
        }
    };

    const handleViewClick = (e: React.MouseEvent) => {
        e.stopPropagation();

        if (notification.actionUrl) {
            if (notification.authenticated) {
                // actionUrl is an authenticated API endpoint: fetch it with the
                // bearer token and download the blob rather than opening a URL
                // that the browser cannot reach without auth.
                downloadFile(notification);
            } else {
                try {
                    const url = new URL(notification.actionUrl);
                    window.open(url.href, '_blank');
                } catch {
                    navigation(notification.actionUrl);
                }
            }
        }

        if (!notification.persist && !notification.readAt) {
            markAsRead(notification.id);
        }

        if (!notification.persist) {
            closeDropdown();
        }
    };

    const handleDismiss = (e: React.MouseEvent) => {
        e.stopPropagation();
        markAsRead(notification.id);
    };

    const calculateDate = () => {
        const date = new Date(notification.createdAt);

        if (isToday(date)) {
            return 'Today';
        }
        if (isYesterday(date)) {
            return 'Yesterday';
        }
        return format(date, 'dd MMMM yyyy');
    };

    const calculateTime = () => {
        const date = new Date(notification.createdAt);
        return format(date, 'HH:mm');
    };

    const renderBullet = () => (
        <div>
            {'\u2022'}
        </div>
    );

    return (
        <Menu.Item
            key={notification.id}
            onClick={handleRowClick}
            className="notification-item-wrapper"
            style={{
                backgroundColor: notification.readAt ? 'white' : '#EDF2F499',
                borderColor: notification.readAt && !isNextUnread ? '#EDF2F4' : '#C0D1D8',
            }}>
            <div className="notification-item">
                {notification.persist && (
                    <button
                        type="button"
                        className="notification-dismiss-btn"
                        onClick={handleDismiss}
                        aria-label="Dismiss notification">
                        <CloseOutlined />
                    </button>
                )}
                <p className="notification-message">{ notification.message }</p>
                <span className="notification-date">
                    { calculateTime() }
                    { renderBullet() }
                    { calculateDate() }
                </span>
                { notification.actionUrl
                    ? <Button className="notification-btn" size="middle" type="primary" onClick={handleViewClick}>View</Button>
                    : null }
            </div>
        </Menu.Item>
    );
};

export default NotificationItem;
